import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { SocketActions } from '@store/socketSaga'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

export const useProjectSocketsInit = () => {
  const dispatch = useDispatch()
  const projectId = useSelector(migrationProjectSelector.getProjectId)

  useEffect(() => {
    if (projectId) {
      dispatch(SocketActions.init())
    }

    return () => {
      dispatch(SocketActions.close())
    }
  }, [projectId])
}
